/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Reset({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Reset_svg__a)"><path fill="currentColor" d="M6.012 1.919A6.37 6.37 0 0 0 3.206 3.76l1.573-.272a.61.61 0 0 1 .702.488.59.59 0 0 1-.48.692L2.15 5.16a.61.61 0 0 1-.702-.487l-.53-2.82a.59.59 0 0 1 .48-.692.61.61 0 0 1 .702.487l.24 1.279a7.57 7.57 0 0 1 3.3-2.15 7.58 7.58 0 0 1 6.122.62 7.56 7.56 0 0 1 2.739 2.664c.348.574.624 1.2.812 1.865a7.5 7.5 0 0 1 .247 1.286 7.56 7.56 0 0 1-.71 4.08 7.6 7.6 0 0 1-1.625 2.231l-.01.01a7.6 7.6 0 0 1-2.854 1.692 7.6 7.6 0 0 1-3.614.274 7.6 7.6 0 0 1-2.581-.935 7.6 7.6 0 0 1-1.976-1.66 7.6 7.6 0 0 1-1.373-2.418 7.56 7.56 0 0 1-.35-3.502.6.6 0 1 1 1.19.162 6.36 6.36 0 0 0 .649 3.777c.226.44.496.843.801 1.206a6.43 6.43 0 0 0 4.611 2.268 6.4 6.4 0 0 0 2.27-.312 6.37 6.37 0 0 0 3.78-3.312c.26-.54.437-1.1.537-1.662a6.41 6.41 0 0 0-1.343-5.153l-.02-.025A6.43 6.43 0 0 0 8.28 1.606a6.4 6.4 0 0 0-2.268.313" /></g><defs><clipPath id="Reset_svg__a"><path fill="currentColor" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;